var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3ExternalWebcam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M702.256 391.939C702.264 391.902 702.268 391.864 702.268 391.825C702.268 391.786 702.264 391.748 702.256 391.71V387.706H689.013V391.72C689.007 391.754 689.004 391.789 689.004 391.825C689.004 391.859 689.007 391.894 689.013 391.929V392.072H689.058C689.248 392.507 689.929 392.828 690.738 392.828H700.534C701.345 392.828 702.025 392.507 702.215 392.072H702.256V391.939Z",
    fill: "#221F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M701.333 390.798C701.339 390.766 701.342 390.733 701.342 390.699C701.342 390.666 701.339 390.633 701.333 390.6V387.155H689.939V390.609C689.933 390.639 689.931 390.669 689.931 390.699C689.931 390.729 689.933 390.759 689.939 390.788V390.911H689.977C690.141 391.285 690.726 391.561 691.423 391.561H699.851C700.548 391.561 701.133 391.285 701.297 390.911H701.333V390.798Z",
    fill: "url(#paint0_linear_2031_1120)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M689.939 380.644V386.605V387.156V387.706H692.53V387.156H698.742V387.706H701.333V387.156V386.605V380.644H689.939Z",
    fill: "url(#paint1_linear_2031_1120)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M710 379.413C710 376.391 707.814 373.911 705.027 373.654V373.631H686.451C683.441 373.631 681 376.22 681 379.413C681 382.605 683.441 385.194 686.451 385.194C686.612 385.194 686.772 385.186 686.93 385.172H704.071C704.229 385.186 704.388 385.194 704.55 385.194C704.711 385.194 704.871 385.186 705.029 385.172C707.814 384.915 710 382.434 710 379.413Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M709.388 379.499C709.388 376.78 707.299 374.548 704.638 374.316V374.296H686.888C684.012 374.296 681.681 376.626 681.681 379.499C681.681 382.373 684.012 384.702 686.888 384.702C687.043 384.702 687.195 384.695 687.346 384.682H703.722C703.873 384.695 704.026 384.702 704.18 384.702C704.334 384.702 704.487 384.695 704.638 384.682C707.299 384.451 709.388 382.219 709.388 379.499Z",
    fill: "url(#paint2_linear_2031_1120)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M690.158 382.222C691.735 380.647 691.735 378.093 690.158 376.518C688.582 374.943 686.025 374.943 684.449 376.518C682.872 378.093 682.872 380.647 684.449 382.222C686.025 383.797 688.582 383.797 690.158 382.222Z",
    fill: "#12100B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M687.271 383.255C689.395 383.255 691.117 381.535 691.117 379.413C691.117 377.291 689.395 375.57 687.271 375.57C685.147 375.57 683.425 377.291 683.425 379.413C683.425 381.535 685.147 383.255 687.271 383.255Z",
    fill: "url(#paint3_linear_2031_1120)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M687.271 381.691C688.559 381.691 689.603 380.648 689.603 379.361C689.603 378.074 688.559 377.031 687.271 377.031C685.983 377.031 684.939 378.074 684.939 379.361C684.939 380.648 685.983 381.691 687.271 381.691Z",
    fill: "#1D1916"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M688.672 379.496C688.793 378.751 688.286 378.049 687.54 377.928C686.795 377.807 686.092 378.313 685.971 379.058C685.85 379.803 686.356 380.505 687.102 380.626C687.848 380.747 688.551 380.241 688.672 379.496Z",
    fill: "#12100B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M687.228 380.051C687.228 380.243 687.072 380.399 686.879 380.399C686.687 380.399 686.531 380.244 686.531 380.051C686.531 379.859 686.686 379.703 686.879 379.703C687.071 379.703 687.228 379.859 687.228 380.051Z",
    fill: "#FEF7FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M692.128 378.411C692.128 378.479 692.072 378.534 692.004 378.534C691.937 378.534 691.881 378.479 691.881 378.411C691.881 378.343 691.937 378.288 692.004 378.288C692.072 378.288 692.128 378.343 692.128 378.411Z",
    fill: "#12100B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M692.128 380.143C692.128 380.211 692.072 380.266 692.004 380.266C691.936 380.266 691.881 380.211 691.881 380.143C691.881 380.075 691.936 380.02 692.004 380.02C692.072 380.02 692.128 380.074 692.128 380.143Z",
    fill: "#12100B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M692.35 378.81C692.339 378.878 692.276 378.924 692.21 378.914C692.142 378.903 692.096 378.84 692.106 378.773C692.116 378.705 692.179 378.659 692.246 378.67C692.314 378.68 692.36 378.743 692.35 378.81Z",
    fill: "#12100B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M692.35 379.707C692.339 379.775 692.276 379.821 692.21 379.811C692.142 379.801 692.096 379.737 692.106 379.671C692.116 379.603 692.179 379.557 692.246 379.567C692.314 379.576 692.36 379.64 692.35 379.707Z",
    fill: "#12100B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M692.407 379.244C692.407 379.311 692.352 379.367 692.284 379.367C692.216 379.367 692.161 379.311 692.161 379.244C692.161 379.176 692.216 379.12 692.284 379.12C692.352 379.12 692.407 379.176 692.407 379.244Z",
    fill: "#12100B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M692.654 378.495C692.654 378.562 692.598 378.618 692.53 378.618C692.463 378.618 692.407 378.562 692.407 378.495C692.407 378.427 692.463 378.371 692.53 378.371C692.598 378.371 692.654 378.427 692.654 378.495Z",
    fill: "#12100B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M692.654 380.226C692.654 380.294 692.598 380.35 692.531 380.35C692.463 380.35 692.407 380.294 692.407 380.226C692.407 380.159 692.463 380.103 692.531 380.103C692.598 380.103 692.654 380.159 692.654 380.226Z",
    fill: "#12100B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M692.876 378.893C692.866 378.961 692.803 379.007 692.736 378.997C692.668 378.987 692.622 378.924 692.633 378.857C692.643 378.789 692.706 378.743 692.773 378.753C692.841 378.763 692.887 378.827 692.876 378.893Z",
    fill: "#12100B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M692.876 379.791C692.866 379.859 692.803 379.905 692.736 379.894C692.668 379.884 692.622 379.821 692.633 379.754C692.643 379.686 692.706 379.64 692.773 379.651C692.841 379.66 692.887 379.723 692.876 379.791Z",
    fill: "#12100B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M692.932 379.327C692.932 379.395 692.877 379.45 692.809 379.45C692.741 379.45 692.686 379.395 692.686 379.327C692.686 379.259 692.741 379.204 692.809 379.204C692.878 379.204 692.932 379.259 692.932 379.327Z",
    fill: "#12100B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2031_1120",
    x1: 695.637,
    y1: 391.562,
    x2: 695.637,
    y2: 387.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3394,
    stopColor: "#4B4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7121,
    stopColor: "#3D3C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2031_1120",
    x1: 689.939,
    y1: 384.175,
    x2: 701.333,
    y2: 384.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#504F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1369,
    stopColor: "#494848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6496,
    stopColor: "#323231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2031_1120",
    x1: 681.68,
    y1: 379.499,
    x2: 709.387,
    y2: 379.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#706F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3C3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2031_1120",
    x1: 684.551,
    y1: 382.13,
    x2: 689.985,
    y2: 376.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    stopColor: "#3B3B3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6728,
    stopColor: "#181817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3ExternalWebcam);
export default __webpack_public_path__ + "static/media/3ExternalWebcam.854664c02523b4c01d02c34b207cbbb9.svg";
export { ForwardRef as ReactComponent };